export default {
    path: '/',
    name: 'home',
    redirect: getRedirectPath(),
}

function getRedirectPath() {
    let path = '/dashboard'
    if (localStorage?.getItem('__IS_FOR_VERCEL__') === 'true') path = '/connect/vercel'
    else if (localStorage?.getItem('__IS_FOR_VERCEL_CONFIG__') === 'true') {
        path = `/integrations${localStorage?.getItem('__VERCEL_CONFIG_SEARCH__')}`
    }
    return path
}

